import React from "react";

// 4 seeds = 1 fig. Each coach message costs 1 seed (0.25 figs).
export const SEEDS_PER_COIN = 4;

/**
 * SeedMeter — circular SVG pie showing seed consumption within the current fig.
 *
 * Props:
 *  - seedsUsed: number  (total seeds spent in this session)
 */
export function SeedMeter({ seedsUsed = 0 }) {
  const size = 36;
  const center = size / 2;
  const r = 15;
  const circ = 2 * Math.PI * r;
  const seedsInCoin = seedsUsed === 0 ? 0 : ((seedsUsed - 1) % SEEDS_PER_COIN) + 1;
  const coinsConsumed = Math.floor(seedsUsed / SEEDS_PER_COIN);
  const filled = (seedsInCoin / SEEDS_PER_COIN) * circ;

  const tooltip =
    seedsUsed === 0
      ? "No seeds used yet · 1 fig = 4 seeds"
      : `${seedsUsed} seed${seedsUsed !== 1 ? "s" : ""} used · ${coinsConsumed} full fig${coinsConsumed !== 1 ? "s" : ""} consumed · 1 fig = 4 seeds`;

  return (
    <div className="seed-meter" title={tooltip}>
      <div className="seed-meter-info seed-meter-info--icon-anchor" title="1 fig = 4 seeds">
        <div className="seed-meter-circle">
          <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
            {/* Track */}
            <circle
              cx={center} cy={center} r={r}
              fill="none"
              stroke="var(--border)"
              strokeWidth="3"
            />
            {/* Filled arc, starts at top */}
            {seedsInCoin > 0 && (
              <circle
                cx={center} cy={center} r={r}
                fill="none"
                stroke="var(--accent, #a78bfa)"
                strokeWidth="3"
                strokeDasharray={`${filled} ${circ}`}
                strokeLinecap="butt"
                transform={`rotate(-90 ${center} ${center})`}
              />
            )}
            {/* Quarter dividers */}
            {[0, 1, 2, 3].map((i) => {
              const a = (i / SEEDS_PER_COIN) * 2 * Math.PI - Math.PI / 2;
              return (
                <line
                  key={i}
                  x1={center + (r - 3) * Math.cos(a)}
                  y1={center + (r - 3) * Math.sin(a)}
                  x2={center + (r + 3) * Math.cos(a)}
                  y2={center + (r + 3) * Math.sin(a)}
                  stroke="var(--card)"
                  strokeWidth="1.5"
                />
              );
            })}

          </svg>
          <span className="seed-meter-badge-bg" aria-hidden="true" />
        </div>
        <span className="seed-meter-info-popup" role="tooltip">1 fig = 4 seeds</span>
      </div>
    </div>
  );
}
